import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import ToastViewModel from '@/Components/Toast/ToastViewModel';
import layout from './Toast.html?raw';
export default class Toast extends Control {
    private jQueryControl: JQuery;

    public constructor(private viewModel: ToastViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.viewModel.addOnClosedCallback((_) => this.onViewModelClosed());

        this.onWidgetCreated(() => this.onWidgetCreatedCallback(null));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyTemplate(layout, this.jQueryControl, () => {
            this.widget(null);
        });

        return this.jQueryControl;
    }

    public appendTo(selector: string) : boolean {
        const $root = $(selector);
        if ($root.length == 0)
            return false;
        
        const $control = this.getControl();
        
        // Es kann sein, dass applyBindings noch nicht durchgeführt wurde.
        // Die Klasse muss gesetzt sein, sonst sieht man ein Flackern.
        $control.addClass('c-toast');
        
        $control.appendTo($root);
        
        // transition in
        window.setTimeout(() => {
            this.jQueryControl.addClass('visible');
        }, this.viewModel.transitionDuration);

        // auto-dismiss, start counting
        window.setTimeout(() => {
            this.viewModel.close();
        }, this.viewModel.autoDismissDelay);

        return true;
    }

    private onViewModelClosed(): void {
        this.jQueryControl.addClass('hidden');

        window.setTimeout(() => {
            if (this.isDisposed)
                return;
            this.jQueryControl.remove();
        }, this.viewModel.transitionDuration);
    }
    
    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'toast',
            controlIdent: this.identifier,
            locator: this.viewModel.locator,
        });
    }
}

ComponentManager.setControl('Toast', Toast, 'RADPresentation.HTMLClient.DefaultViewExtensions');